import { getAuth } from "firebase/auth";
import { getApiUrl } from "./config";

const getBase = () => getApiUrl();

async function authHeaders() {
  const user = getAuth().currentUser;
  const token = user ? await user.getIdToken() : null;
  return {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  };
}

export async function fetchLandlordNotifications({
  limit = 15,
  cursor = null,
} = {}) {
  const params = new URLSearchParams();
  params.set("limit", String(limit));
  if (cursor != null && cursor !== "") params.set("cursor", String(cursor));
  const res = await fetch(`${getBase()}/notifications?${params.toString()}`, {
    headers: await authHeaders(),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed to load notifications (${res.status})`);
  }
  return res.json();
}

export async function markLandlordNotificationsRead(ids) {
  const res = await fetch(`${getBase()}/notifications/read`, {
    method: "POST",
    headers: await authHeaders(),
    body: JSON.stringify({ ids }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed to mark read (${res.status})`);
  }
  return res.json();
}

export async function markAllLandlordNotificationsRead(ids) {
  const res = await fetch(`${getBase()}/notifications/read-all`, {
    method: "POST",
    headers: await authHeaders(),
    body: JSON.stringify(ids ? { ids } : {}),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed to mark all read (${res.status})`);
  }
  return res.json();
}
